import { render, staticRenderFns } from "./UniMaker.vue?vue&type=template&id=6bd40970&scoped=true&"
import script from "./UniMaker.vue?vue&type=script&lang=ts&"
export * from "./UniMaker.vue?vue&type=script&lang=ts&"
import style0 from "./UniMaker.vue?vue&type=style&index=0&id=6bd40970&prod&lang=css&"
import style1 from "./UniMaker.vue?vue&type=style&index=1&id=6bd40970&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd40970",
  null
  
)

export default component.exports